import { Header, Icon } from "semantic-ui-react";

export default function CommingSoon() {
    return <div>
        <Header as='h2' icon textAlign='center'>
            <Icon name='wait' />
            <Header.Content>Comming soon</Header.Content>
        </Header>
    </div>
};